module.exports = __webpack_public_path__ + "static/media/sub-card-label-4.0b995b54.svg";